function toggleAdvancedSearch() {
    const advancedSearchButton = document.querySelector(".advanced-search");
    const mobileAdvancedSearchButton = document.querySelector(
        ".mobmenu-content .advanced-search"
    );
    const advancedSearchWrapper = document.querySelector(
        ".advanced-search-wrapper"
    );
    const advancedSearchWrapperMobile = document.querySelector(
        ".mobmenu-content .advanced-search-wrapper"
    );
    const otsinguKast = document.querySelector(".otsingu-kast");
    const otsinguKastMobile = document.querySelector(
        ".mobmenu-content .otsingu-kast"
    );
    const searchForm = document.querySelector(".advanced-search-wrapper .searchform");
    const searchFormMobile = document.querySelector(
        ".mobmenu-content .searchform"
    );
    const searchFromOthersList = document.querySelectorAll(
        ".otsi-teistest input"
    );
    const otherSearchSitesList = document.querySelectorAll(
        ".other-search-sites"
    );
    const selectAllSitesList = document.querySelectorAll(".select-all-sites");
    const deselectAllSitesList = document.querySelectorAll(
        ".deselect-all-sites"
    );

    selectAllSitesList.forEach((selectAllSites, i) => {
        const deselectAllSites = deselectAllSitesList[i];
        const otherSearchSitesInputs =
            otherSearchSitesList[i].querySelectorAll("input");

        if (selectAllSites && otherSearchSitesInputs) {
            selectAllSites.addEventListener("click", function () {
                otherSearchSitesInputs.forEach((input) => {
                    input.checked = true;
                });
            });
        }

        if (deselectAllSites && otherSearchSitesInputs) {
            deselectAllSites.addEventListener("click", function () {
                otherSearchSitesInputs.forEach((input) => {
                    input.checked = false;
                });
            });
        }
    });

    searchFromOthersList.forEach((searchFromOthers, i) => {
        const otherSearchSites = otherSearchSitesList[i];
        const otherSearchSitesInputs =
            otherSearchSitesList[i].querySelectorAll("input");
        if (otherSearchSites) {
            searchFromOthers.addEventListener("click", function () {
                if (otherSearchSites.style.display === "none") {
                    otherSearchSites.style.display = "block";
                    otherSearchSitesInputs.forEach((input) => {
                        input.disabled = false;
                    });
                } else {
                    otherSearchSites.style.display = "none";
                    otherSearchSitesInputs.forEach((input) => {
                        input.disabled = true;
                    });
                }
            });
        }
    });

    if (advancedSearchButton && advancedSearchWrapper) {
        advancedSearchButton.addEventListener("click", function () {
            advancedSearchWrapper.style.display = "block";
        });

        advancedSearchWrapper.addEventListener("click", function (event) {
            if (!otsinguKast.contains(event.target)) {
                advancedSearchWrapper.style.display = "none";
            }
        });
    }

    if (searchForm) {
        const searchInput = searchForm.querySelector(".search-input-wrapper > input");

        
        if (searchInput) {
            const clearButton = document.createElement("div");
            clearButton.classList.add("clear-button");


            searchForm.style.position = "relative";

            searchForm.appendChild(clearButton);

            clearButton.addEventListener("click", function () {
                advancedSearchWrapper.style.display = "none";
            });
        }
    }


    // if (mobileAdvancedSearchButton) {
    //     mobileAdvancedSearchButton.addEventListener("click", function () {
    //         advancedSearchWrapperMobile.style.display = "block";
    //     });
    //     const searchInput = searchFormMobile.querySelector(
    //         ".mobmenu-content .searchform .search-input-wrapper > input"
    //     );

    //     if (searchInput) {
    //         const clearButton = document.createElement("div");
    //         clearButton.classList.add("clear-button");

    //         searchFormMobile.style.position = "relative";

    //         searchFormMobile.appendChild(clearButton);

    //         clearButton.addEventListener("click", function () {
    //             advancedSearchWrapperMobile.style.display = "none";
    //         });
    //     }
    // }

    advancedSearchWrapperMobile.addEventListener("click", function (event) {
        if (!otsinguKastMobile.contains(event.target)) {
            advancedSearchWrapperMobile.style.display = "none";
        }
    });



}

export default toggleAdvancedSearch;
